import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let ourTeamSwiperWr = document.querySelectorAll('.our-team-swiper-wr');

const ourTeamBreakpoints = {
  641: {
    slidesPerView: 2,
    spaceBetween: 20,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 30,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 30,
  },
  1100: {
    slidesPerView: 4,
    spaceBetween: 30,
  },
  1200: {
    slidesPerView: 4,
    spaceBetween: 42,
  },
};

let initSlideBtnRoll = () => {
  if (typeof window.initBtnRoll === 'function') {
    window.initBtnRoll();
  }
};

let updateTeamStagger = (swiperInstance) => {
  if (!swiperInstance?.slides?.length) {
    return;
  }

  swiperInstance.slides.forEach((slide, index) => {
    let offset = index - swiperInstance.activeIndex;

    slide.classList.toggle('is-staggered-slide', Math.abs(offset) % 2 === 0);
  });
};

let updateLoopSlides = (swiperInstance) => {
  if (!swiperInstance || !swiperInstance.params.loop) return;

  requestAnimationFrame(() => {
    swiperInstance.update();
    swiperInstance.loopFix();
    updateTeamStagger(swiperInstance);
    initSlideBtnRoll();
  });
};

ourTeamSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');

    if (!swiperEl) {
      return;
    }

    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    if (!wrapper) {
      return;
    }

    let originalSlidesHTML = wrapper.innerHTML;
    let slidesCount = wrapper.querySelectorAll('.swiper-slide').length;

    let getCurrentSlidesPerView = () => {
      return Object.keys(ourTeamBreakpoints).reduce((slidesPerView, breakpoint) => {
        if (window.innerWidth >= Number(breakpoint)) {
          return ourTeamBreakpoints[breakpoint].slidesPerView;
        }

        return slidesPerView;
      }, 1);
    };

    let shouldUseLoop = () => slidesCount > getCurrentSlidesPerView();

    let observer = null;

    let buildSwiper = () => {
      let isLoop = shouldUseLoop();

      wrapper.innerHTML = originalSlidesHTML;

      return new Swiper(swiperEl, {
        modules: [Autoplay, Navigation, Pagination],
        observer: true, //needs to calculate swiper size
        observeParents: true, //needs to calculate swiper size
        loop: isLoop,
        loopedSlides: isLoop ? slidesCount : null,
        loopAdditionalSlides: isLoop ? slidesCount : 0,
        watchOverflow: false,
        watchSlidesProgress: true,
        spaceBetween: 24,
        slidesPerView: 1,
        threshold: 10,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: ourTeamBreakpoints,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: window.innerWidth >= 1033,
        },
        on: {
          init(swiperInstance) {
            updateLoopSlides(swiperInstance);
            updateTeamStagger(swiperInstance);
            initSlideBtnRoll();
          },
          resize(swiperInstance) {
            updateLoopSlides(swiperInstance);
            updateTeamStagger(swiperInstance);
          },
          breakpoint(swiperInstance) {
            updateLoopSlides(swiperInstance);
            updateTeamStagger(swiperInstance);
          },
          slideChange(swiperInstance) {
            updateTeamStagger(swiperInstance);
          },
          slideChangeTransitionEnd(swiperInstance) {
            updateTeamStagger(swiperInstance);
            initSlideBtnRoll();
          },
        },
      });
    };

    let swiper = buildSwiper();
    updateLoopSlides(swiper);
    updateTeamStagger(swiper);
    initSlideBtnRoll();
    observer = swiperObserver(swiper);

    window.addEventListener('resize', () => {
      let nextLoop = shouldUseLoop();

      if (nextLoop === swiper.params.loop) {
        return;
      }

      observer?.disconnect();
      swiper.destroy(true, true);
      swiper = buildSwiper();
      updateLoopSlides(swiper);
      initSlideBtnRoll();
      observer = swiperObserver(swiper);
    });
  }
});
